import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import segment from '@flipster/utils/segment';

import { SegmentPage } from '../../../misc/segment/segment-page';
import { profileBunja } from '../../bunja';
import { editProfileBunja } from './bunja';

export const EditProfileModalSegmentView = () => {
  const { isMasterTraderAtom, profileAtom } = useBunja(editProfileModalSegmentBunja);
  const isMasterTrader = useAtomValue(isMasterTraderAtom);
  const profile = useAtomValue(profileAtom);
  if (!isMasterTrader || !profile) return null;
  return <SegmentPage name='copytrading_profile_edit_visit' context={{ master_nickname: profile.nickname }} />;
};

export const editProfileModalSegmentBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { profileAtom } = bunja.use(profileBunja);
  const { isMasterTraderAtom } = bunja.use(editProfileBunja);

  function trackEditProfileSaveClick() {
    const profile = store.get(profileAtom);
    if (!profile) return;
    if (profile.copyTradeMasterProfile) {
      segment.track('copytrading_profile_edit_click_save', { master_nickname: profile.nickname });
    }
  }

  return {
    profileAtom,
    isMasterTraderAtom,
    trackEditProfileSaveClick,
  };
});
editProfileModalSegmentBunja.debugLabel = 'editProfileModalSegmentBunja';
